import React from 'react';

// Peças visuais compartilhadas pelas etapas do Fechamento do mês.

export const ROXO = '#7c3aed';
export const TEXTO = '#1c1530';
export const SUAVE = '#5f5874';
export const BORDA = '#e5e0ef';
export const VERDE = '#047857';
export const AMBAR = '#b45309';
export const VERMELHO = '#b91c1c';

export const fmtMoeda = (v) => Number(v || 0).toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' });
export const fmtData = (iso) => (iso ? String(iso).slice(0, 10).split('-').reverse().join('/') : '—');
export const fmtDataHora = (iso) => {
  if (!iso) return '—';
  const d = new Date(iso);
  if (Number.isNaN(d.getTime())) return '—';
  return `${d.toLocaleDateString('pt-BR')} ${d.toLocaleTimeString('pt-BR', { hour: '2-digit', minute: '2-digit' })}`;
};

export const botaoPrimario = { background: ROXO, color: 'white', border: 'none', borderRadius: 8, padding: '8px 18px', fontSize: 13, fontWeight: 700, cursor: 'pointer' };
export const botaoSecundario = { background: 'transparent', color: SUAVE, border: `1px solid ${BORDA}`, borderRadius: 8, padding: '8px 18px', fontSize: 13, fontWeight: 600, cursor: 'pointer' };
export const botaoPequeno = { background: 'transparent', color: SUAVE, border: `1px solid ${BORDA}`, borderRadius: 6, padding: '4px 10px', fontSize: 12, fontWeight: 600, cursor: 'pointer' };
export const th = { textAlign: 'left', padding: '6px 8px', fontSize: 11, color: SUAVE, fontWeight: 700, textTransform: 'uppercase', borderBottom: `1px solid ${BORDA}`, position: 'sticky', top: 0, background: '#ffffff', zIndex: 1 };
export const td = { padding: '6px 8px', fontSize: 12, color: TEXTO, borderBottom: '1px solid #f1eef7', verticalAlign: 'top' };

// Texto só para leitor de tela (cabeçalho de coluna de ações etc.).
export const srOnly = { position: 'absolute', width: 1, height: 1, padding: 0, margin: -1, overflow: 'hidden', clip: 'rect(0,0,0,0)', whiteSpace: 'nowrap', border: 0 };

export const desabilitado = (estilo, off) => (off ? { ...estilo, opacity: 0.5, cursor: 'not-allowed' } : estilo);

export function Aviso({ aviso, onFechar }) {
  if (!aviso) return null;
  const cores = {
    sucesso: { bg: 'rgba(16,185,129,0.08)', borda: 'rgba(16,185,129,0.35)', cor: VERDE },
    erro: { bg: 'rgba(239,68,68,0.08)', borda: 'rgba(239,68,68,0.35)', cor: VERMELHO },
    info: { bg: 'rgba(96,165,250,0.08)', borda: 'rgba(96,165,250,0.35)', cor: '#1d4ed8' },
    alerta: { bg: 'rgba(245,158,11,0.08)', borda: 'rgba(245,158,11,0.35)', cor: AMBAR },
  }[aviso.tipo] || {};
  return (
    <div role={aviso.tipo === 'erro' ? 'alert' : 'status'} style={{ display: 'flex', justifyContent: 'space-between', gap: 12, alignItems: 'flex-start', background: cores.bg, border: `1px solid ${cores.borda}`, borderRadius: 8, padding: '10px 14px', marginBottom: '1rem', fontSize: 13, color: cores.cor }}>
      <span>{aviso.texto}</span>
      {onFechar && (
        <button onClick={onFechar} aria-label="Fechar aviso" style={{ background: 'transparent', border: 'none', color: cores.cor, cursor: 'pointer', fontSize: 16, lineHeight: 1 }}>×</button>
      )}
    </div>
  );
}

export const SITUACAO = {
  pendente: { rotulo: 'Pendente', cor: AMBAR, bg: 'rgba(245,158,11,0.12)' },
  validada: { rotulo: 'Validada', cor: VERDE, bg: 'rgba(16,185,129,0.12)' },
  desatualizada: { rotulo: 'Alterada após a validação', cor: VERMELHO, bg: 'rgba(239,68,68,0.10)' },
};

export function SeloSituacao({ situacao }) {
  const s = SITUACAO[situacao] || SITUACAO.pendente;
  return (
    <span style={{ fontSize: 10, fontWeight: 700, color: s.cor, background: s.bg, borderRadius: 10, padding: '2px 8px', whiteSpace: 'nowrap' }}>{s.rotulo}</span>
  );
}

/**
 * Seleção de conta com busca (campo de texto + lista do navegador).
 * `contas` = [{ codigo, rotulo }]; `valor` = rótulo escolhido ou ''.
 * Só aceita um rótulo existente: texto livre não vira conta.
 */
export function SeletorConta({ id, contas, valor, onChange, inputStyle, placeholder = 'Digite o código ou o nome da conta' }) {
  const [texto, setTexto] = React.useState(valor || '');
  // Valor limpo por fora (ex.: depois de salvar) limpa o campo; texto parcial em
  // digitação (que ainda não é conta) fica como está.
  React.useEffect(() => {
    if (valor) setTexto(valor);
    else setTexto(t => (contas.some(c => c.rotulo === t) ? '' : t));
  }, [valor]); // eslint-disable-line react-hooks/exhaustive-deps
  const listaId = `${id}-lista`;
  const aoDigitar = (e) => {
    const t = e.target.value;
    setTexto(t);
    const achou = contas.find(c => c.rotulo === t);
    onChange(achou ? achou.rotulo : '');
  };
  const invalido = texto && !contas.some(c => c.rotulo === texto);
  return (
    <>
      <input
        id={id}
        list={listaId}
        value={texto}
        onChange={aoDigitar}
        placeholder={placeholder}
        aria-invalid={invalido || undefined}
        style={{ ...inputStyle, ...(invalido ? { border: '1px solid #f59e0b' } : {}) }}
        autoComplete="off"
      />
      <datalist id={listaId}>
        {contas.map(c => <option key={c.codigo} value={c.rotulo} />)}
      </datalist>
    </>
  );
}
